import React from 'react';
import { LoadingSpinner } from '../../../components/atoms/LoadingSpinner';

export default function GalleryLoadingSpinner() {
  return (
    <div className="image-gallery__loading">
      <div className="image-gallery__spinner">
        <LoadingSpinner />
      </div>
    </div>
  );
}
